import { HtmlContent } from "@vega-core/components/HtmlContent/HtmlContent";
import { m } from "@vega-core/paraglide/messages";
import { formatShortSlashDate } from "@vega-core/utils/formatDate";

type Props = {
  closingDate?: string;
};

export const DealStillActiveBanner = ({ closingDate }: Props) => (
  <div
    className="max-w-3xl mx-auto border border-border/primary rounded-companyBorderRadius card-paddings-default text-center space-y-3"
    data-testid="report-still-active"
  >
    <h2 className="heading-5">{m.coInvestments_report_stillActive_title()}</h2>
    <div className="body-base-regular text-text/secondary">
      <HtmlContent
        content={m.coInvestments_report_stillActive_description({
          closeDateLine: closingDate
            ? m.coInvestments_report_stillActive_closeDateLine({
                date: formatShortSlashDate(closingDate),
              })
            : "",
        })}
      />
    </div>
  </div>
);
